import { Component, Inject, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { SpinnerService } from '../../services/spinner.service';
import { DownloadService } from '../../services/download.service';
import { SnackbarService } from '../../services/snackbar.service';
import {
  FacturaEstadoDTO,
  FacturaGestorAcuerdoFilterDTO,
  FacturaPoseedorEstadosControllerService,
  FacturaGestorAcuerdoControllerService,
  DiccionarioControllerService,
  DiccionarioElementoDTO
} from 'api-rest';
import { DocumentService } from '../../services/document.service';
import moment from 'moment';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { DatePipe } from '@angular/common';
import { ManagersAgreementsInvoiceNewDocumentDialogComponent } from '../managers-agreements-invoice-document-dialog/managers-agreements-invoice-document-dialog.component';
import { ManagersAgreementsInvoiceRejectDialogComponent } from '../managers-agreements-invoice-reject-dialog/managers-agreements-invoice-reject-dialog.component';
import { ManagersAgreementsInvoicesDetailDialogComponent } from '../managers-agreements-invoices-detail-dialog/managers-agreements-invoices-detail-dialog.component';
import { ManagersAgreementsInvoiceAccountingDialogComponent } from '../managers-agreements-invoice-accounting-dialog/managers-agreements-invoice-accounting-dialog.component';
import { ManagersAgreementsSelfInvoicesCancelRevisionDialogComponent } from '../managers-agreements-self-invoices-cancel-revision-dialog/managers-agreements-self-invoices-cancel-revision-dialog.component';
import { FormatCurrencyPipe } from '../../share/components/pipe/FormatCurrency.pipe';

@Component({
  selector: 'app-managers-agreements-self-invoices-search',
  templateUrl: './managers-agreements-self-invoices-search.component.html',
  styleUrls: ['./managers-agreements-self-invoices-search.component.scss'],
})
export class ManagersAgreementsSelfInvoicesSearchComponent implements OnInit {

  listaGestores = this.environment.urlBackCore + 'api/v1/acuerdo-indirecto/gestores/byUser';

  defaultGestoresParameters = { 'gestoresResiduosEstado.id': 2, 'acuerdoEnvalora': true };
  updateList: boolean = false;

  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;

  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  flagSearch: boolean = false;
  totalElements: number = 0;
  totalSearch: number = 0;

  gestorArray: any[] = [];
  estadoArray: any[] = [];
  mostrarFiltros: boolean = true;
  orden: DiccionarioElementoDTO[] = [];

  headArray: any = [
    {
      Head: 'ID. Gestor',
      FieldName: 'gestoresResiduos',
      Attribute: 'id'
    },
    {
      Head: 'Gestor',
      FieldName: 'gestoresResiduos',
      Attribute: 'razonSocial',
    },
    {
      Head: 'Documento',
      FieldName: 'gestoresResiduos',
      Attribute: 'codigoDocumento',
    },
    {
      Head: 'NIMA del gestor',
      FieldName: 'gestoresResiduos',
      Attribute: 'nima',
    },
    {
      Head: 'Número de prefactura',
      FieldName: 'documentoAutofactura',
      renderValue: (item: any) =>
        item.fechaAutofactura !== null ? item.id : '',
    },
    {
      Head: 'Fecha de prefactura',
      FieldName: 'fechaMAutofactura',
    },
    {
      Head: 'Número factura gestor ',
      FieldName: 'numeroFactura',
    },
    {
      Head: 'Fecha factura',
      FieldName: 'fechaMFactura',
    },
    {
      Head: 'Estado ',
      FieldName: 'estado',
      renderValue: (item: any) =>
        item.estado?.descripcion
    },
    ...((this.canViewRegistrada())
      ? [
        {
          Head: 'Registrada',
          FieldName: 'registrada',
          renderValue: (item: any) =>
            item.registrada ? 'Sí' : 'No',
        },
      ]
      : []),
    {
      Head: 'Número de factura UIPATH',
      FieldName: 'numeroFacturaUipath',
    },
    {
      Head: 'Fecha de factura UIPATH',
      FieldName: 'fechaMFacturaUipath',
    },
    {
      Head: 'CIF Gestor',
      FieldName: 'cifPoseedorUipath',
    },
    {
      Head: 'Base imponible / Importe',
      FieldName: 'baseImponibleUipath',
      renderValue: (item: any) => this.formatCurrencyPipe.transform(item.baseImponibleUipath),
    },
    {
      Head: 'Tipo de IVA',
      FieldName: 'tipoIVAUipath',
      renderValue: (item: any) => this.formatCurrencyPipe.transform(item.tipoIVAUipath),
    },
    {
      Head: 'Importe de IVA',
      FieldName: 'importeIVAUipath',
      renderValue: (item: any) => this.formatCurrencyPipe.transform(item.importeIVAUipath),
    },
    {
      Head: 'Total factura',
      FieldName: 'totalFacturaUipath',
      renderValue: (item: any) => this.formatCurrencyPipe.transform(item.totalFacturaUipath),
    },
    {
      Head: 'IBAN',
      FieldName: 'ibanUipath',
    },
    {
      Head: 'SWITF',
      FieldName: 'swiftUipath',
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Detalle ',
          show: {
            params: 'canAccessView',
            accion: 'view',
          },
        },
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Eliminar registro',
          show: { params: 'canAccessDelete' },
        },
        {
          nameButton: 'add_invoice',
          icon: 'upload_file',
          toolTip: 'Adjuntar factura',
          show: { params: 'canAccessUpInvoice' },
        },
        {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'download_invoice',
              name: 'Descargar factura',
              show: { params: 'canAccessDonwloadInvoice' },
            },
            {
              nameButton: 'download_self_invoice',
              name: 'Descargar prefactura',
              show: { params: 'canAccessDonwloadSelfInvoice' },
            },
            {
              nameButton: 'accept_invoice',
              name: 'Aceptar factura',
              show: { params: 'canAccessAcceptInvoice' },
            },
            {
              nameButton: 'download_pre_invoice_detail',
              name: 'Descargar detalle prefacturación',
              show: { params: 'canAccessDonwloadSelfInvoice' },
            },
            {
              nameButton: 'reject_invoice',
              name: 'Rechazar',
              show: { params: 'canRejectInvoice' },
            },
            {
              nameButton: 'registrate',
              name: 'Registrar',
              show: { params: 'canAccessRegistrate' },
            },
            {
              nameButton: 'accept_invoice_revision',
              name: 'Aceptar',
              show: { params: 'canAccessAcceptInvoiceRevision' },
            },
            {
              nameButton: 'reject_invoice_revision',
              name: 'Rechazar',
              show: { params: 'canRejectInvoiceRevision' },
            },
          ],
        },
      ],
      permanent: true,
    },
  ];
  gridArray: any[] = [];

  searchForm: FormGroup;

  constructor(
    @Inject('environment') private environment: any,
    @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService | any,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private facturaGestorAcuerdoControllerService: FacturaGestorAcuerdoControllerService,
    private facturaPoseedorEstadosControllerService: FacturaPoseedorEstadosControllerService,
    private downloadService: DownloadService,
    private documentService: DocumentService,
    private snackBarSrv: SnackbarService,
    private datePipe: DatePipe,
    private formatCurrencyPipe: FormatCurrencyPipe,
    private diccionarioControllerService: DiccionarioControllerService
  ) {
    this.searchForm = this.formBuilder.group({
      gestor: [{ value: null, disabled: false }],
      idgestor: [{ value: null, disabled: false }],
      codigo_documento: [{ value: null, disabled: false }],
      razon_social: [{ value: null, disabled: false }],
      nima_gestor: [{ value: null, disabled: false }],
      numero_autoFactura: [{ value: null, disabled: false }, [Validators.pattern('^[0-9]+$'), Validators.maxLength(10)]],
      fecha_autoFactura: [{ value: null, disabled: false }],
      numero_facturaGestor: [{ value: null, disabled: false }, [Validators.maxLength(20)]],
      fecha_facturaGestor: [{ value: null, disabled: false }],
      estado: [{ value: null, disabled: false }],
      registrada: [{ value: null, disabled: false }],
      abonoS: [{ value: false, disabled: false }],
      abonoN: [{ value: false, disabled: false }],
      orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],
    });
  }

  ngOnInit() {
    this.comboEstados();
    this.comboOrden();
    // this.getGestores();
  }

  comboOrden() {
 this.diccionarioControllerService.listarElementos(['ORDEN_ACUERDO_INDIRECTO_APORTACIONES_DI_FS_BUSQUEDA'])
      .subscribe({
        next: (data: any) => {
          this.orden = data['ORDEN_ACUERDO_INDIRECTO_APORTACIONES_DI_FS_BUSQUEDA'];
        },
        error: () => {},
      });
  }

  checked(event: any) { }

  renderPage(event: number) {
    this.pageNumber = event;
    if (this.flagSearch) {
      this.searchData();
    }
  }

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'gestor': {
        return this.searchForm.get('gestor') as FormControl;
      }
      default: {
        return this.searchForm.get('') as FormControl;
      }
    }
  }

  getGestorDescription(obj: any) {
    return  obj?.razonSocial + ' - ' + obj?.nima + ' - ' + obj?.centro;
  }

  getGestorObjectQuery(searchterm: string) {
    return {
      razonSocialOrNima: searchterm,
      'estado.id': 4,
    };
  }

  exportarExcel() {
    const { backendFilter, page, size } = this.getBackendFilter();
    this.facturaGestorAcuerdoControllerService
      .exportCSV2(backendFilter, 'response')
      .subscribe((res: any) => {
        this.downloadService.exportModal();
        // const filename = this.downloadService.getFileName(
        //   res.headers,
        //   'Exportacion_Factura_Gestor.csv'
        // );
        // this.downloadService.downloadCSV(res.body!, filename!);
      });
  }

  clearSearcher() {
    this.searchForm.reset();
    this.flagSearch = false;
    this.gridArray = [];
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    if (filtro.value !== undefined) {
      const current = this.searchForm.get(filtro.campo)?.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v: any) => {
          if (typeof v === 'object' && typeof filtro.value === 'object') {
            const currentId = v?.id ?? v;
            const targetId = filtro.value?.id ?? filtro.value;
            return currentId !== targetId;
          }
          return v !== filtro.value;
        });
        this.searchForm.get(filtro.campo)?.setValue(updated.length ? updated : null);
      }
    } else {
      this.searchForm.get(filtro.campo)?.reset();
    }
    this.pageNumber = 0;
    //this.searchData(true);
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const gestores = this.searchForm.get('gestor')?.value as any[];
    if (gestores?.length) {
      gestores.forEach((gestor: any) => {
        const label = gestor?.razonSocial ?? String(gestor?.id ?? gestor);
        filtros.push({ label: ` ${label}`, campo: 'gestor', value: gestor });
      });
    }

    const idGestor = this.searchForm.get('idgestor')?.value;
    if (idGestor) {
      filtros.push({ label: ` ${idGestor}`, campo: 'idgestor' });
    }

    const codigoDocumento = this.searchForm.get('codigo_documento')?.value;
    if (codigoDocumento?.trim()) {
      filtros.push({ label: ` ${codigoDocumento.trim()}`, campo: 'codigo_documento' });
    }

    const razonSocial = this.searchForm.get('razon_social')?.value;
    if (razonSocial?.trim()) {
      filtros.push({ label: ` ${razonSocial.trim()}`, campo: 'razon_social' });
    }

    const nimaGestor = this.searchForm.get('nima_gestor')?.value;
    if (nimaGestor?.trim()) {
      filtros.push({ label: ` ${nimaGestor.trim()}`, campo: 'nima_gestor' });
    }

    const numeroAutoFactura = this.searchForm.get('numero_autoFactura')?.value;
    if (numeroAutoFactura) {
      filtros.push({ label: ` ${numeroAutoFactura}`, campo: 'numero_autoFactura' });
    }

    const fechaAutoFactura = this.searchForm.get('fecha_autoFactura')?.value;
    if (fechaAutoFactura) {
      filtros.push({
        label: ` ${this.datePipe.transform(fechaAutoFactura, 'dd/MM/yyyy')}`,
        campo: 'fecha_autoFactura',
      });
    }

    const numeroFacturaGestor = this.searchForm.get('numero_facturaGestor')?.value;
    if (numeroFacturaGestor?.trim()) {
      filtros.push({ label: ` ${numeroFacturaGestor.trim()}`, campo: 'numero_facturaGestor' });
    }

    const fechaFacturaGestor = this.searchForm.get('fecha_facturaGestor')?.value;
    if (fechaFacturaGestor) {
      filtros.push({
        label: ` ${this.datePipe.transform(fechaFacturaGestor, 'dd/MM/yyyy')}`,
        campo: 'fecha_facturaGestor',
      });
    }

    const estados = this.searchForm.get('estado')?.value as any[];
    if (estados?.length) {
      estados.forEach((estado: any) => {
        filtros.push({
          label: `${estado?.descripcion ?? String(estado)}`,
          campo: 'estado',
          value: estado,
        });
      });
    }
const ordenes = this.searchForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }
    return filtros;
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.searchForm.controls[controlName].hasError(errorName) &&
      this.searchForm.controls[controlName].touched
    );
  }

  private getBackendFilter() {
    const {
      gestor,
      idgestor,
      razon_social,
      nima_gestor,
      numero_autoFactura,
      fecha_autoFactura,
      numero_facturaGestor,
      fecha_facturaGestor,
      estado,
      codigo_documento,
    } = this.searchForm.controls;

    const formatDate = (date: any) => {
      if (date && date.value) {
        return moment(new Date(date.value)).format('DD/MM/YYYY');
      }
      return undefined;
    };

    const selectGestores = this.searchForm.get('gestor')?.value;

    let registrada;
    if (this.searchForm.get('registrada')?.value) {
      registrada = this.searchForm.get('registrada')?.value;
    }

    let abono;
    if (this.searchForm.get('abonoS')?.value === true) {
      abono = 'SI';
    } else if (this.searchForm.get('abonoN')?.value === true) {
      abono = 'NO';
    }

    const backendFilter: FacturaGestorAcuerdoFilterDTO = {
      gestoresResiduos: {
        id: gestor.value != null
          ? selectGestores?.map((objeto: any) =>
            objeto.id !== undefined ? objeto.id : objeto)
          : [],

        razonSocial: razon_social?.value ? razon_social?.value.trim() : undefined,
        nima: nima_gestor?.value,
        codigoDocumento: codigo_documento?.value,
      },
      id: Number(idgestor?.value) || Number(gestor?.value) || undefined,
      numeroAutofactura: numero_autoFactura?.value,
      fechaAutofactura: formatDate(fecha_autoFactura),
      numeroFactura: numero_facturaGestor?.value,
      fechaFactura: formatDate(fecha_facturaGestor),
      estado: estado?.value,
      registrada: registrada,
      abono: abono,
    };

    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    const orden = this.searchForm.get('orden')?.value;
    const tipoOrden = this.searchForm.get('tipoOrden')?.value;

    return { backendFilter, page, size: this.pageSize, orden, tipoOrden };
  }

  
searchData(initPage: boolean = false) {
  if (initPage) {
    this.pageNumber = 0;
  }
  if (this.searchForm.invalid) {
    this.searchForm.markAllAsTouched();
    return;
  }
  const { backendFilter, page, size, orden, tipoOrden } = this.getBackendFilter();
  this.spinnerSrv.loadingShow();
  this.facturaGestorAcuerdoControllerService
    .findAll1(backendFilter, {
      page: page,
      size: size,
      sort: ['id,desc'],
    },
      orden,
      tipoOrden)
    .subscribe({
      next: (data: any) => {
        if (data) {
          this.spinnerSrv.loadingHide();
          this.flagSearch = data.datos?.length != 0 ? true : false;
          this.gridArray = this.canAccessAll(data.datos) ?? [];
          this.recordsTotal = data.paginacion?.totalElements ?? 0;
          this.totalSearch = this.gridArray.length;
        }
      },
      error: (error: any) => {
        this.spinnerSrv.loadingHide();
      },
    });
}

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.searchData();
  }

  onAbonoChange(tipo: 'S' | 'N', checked: boolean) {
    if (!checked) {
      return;
    }
    if (tipo === 'S') {
      this.searchForm.get('abonoN')?.setValue(false);
    } else {
      this.searchForm.get('abonoS')?.setValue(false);
    }
  }

  action(element: any) {
    if (element.nameButton == 'view') {
      this.openModalDetail(element);
    } else if (element.nameButton == 'delete') {
      this.confirmacionEliminar(element);
    } else if (element.nameButton == 'add_invoice') {
      this.openModalUploadInvoice(element);
    } else if (element.nameButton == 'download_invoice') {
      this.descargar(element.documento);
    } else if (element.nameButton == 'download_self_invoice') {
      this.descargar(element.documentoAutofactura);
    } else if (element.nameButton == 'accept_invoice') {
      this.confirmacionCambioEstado(element.id, 3);
    } else if (element.nameButton == 'download_pre_invoice_detail') {
      this.descargarDetallePrefacturacion(element);
    }else if(element.nameButton == 'reject_invoice'){
      this.openModalMotivoRechazo(element);
    } else if (element.nameButton == 'registrate') {
      this.registrarFactura(element);
    } else if (element.nameButton == 'accept_invoice_revision') {
      this.aceptarFacturaRevision(element);
    } else if (element.nameButton == 'reject_invoice_revision') {
      this.cancelarFacturaRevision(element);
    }
  }

  openModalDetail(element?: any): void {
    const dialogRef = this.dialog.open(
      ManagersAgreementsInvoicesDetailDialogComponent,
      {
        width: '950px',
        maxWidth: '98%',
        maxHeight: '95vh',
        data: element,
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }

  openModalAccounting(): void {
    const dialogRef = this.dialog.open(
      ManagersAgreementsInvoiceAccountingDialogComponent,
      {
        width: '650px',
        maxWidth: '95%',
        maxHeight: '95vh',
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }

  aceptarFacturaRevision(element: any) {
    this.spinnerSrv.loadingShow();
    this.facturaGestorAcuerdoControllerService.actualizarEstado(element.id, 3).subscribe({
      next: (res: any) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Factura aceptada correctamente',
          'success'
        );
        this.searchData();
      },
      error: (err: any) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Error al aceptar la factura',
          'error'
        );
      }
    });
  }

  cancelarFacturaRevision(element: any) {
    const dialogRef = this.dialog.open(
      ManagersAgreementsSelfInvoicesCancelRevisionDialogComponent,
      {
        width: '750px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          info: element,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }

  confirmacionEliminar(element?: any): void {
    Swal.fire({
      text: `¿Desea eliminar la prefactura?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminarInvoices(element);
      }
    });
  }

  eliminarInvoices(element?: any) {
    if (element?.id) {
      this.spinnerSrv.loadingShow();
      this.facturaGestorAcuerdoControllerService.deleteById1(element.id).subscribe({
        next: () => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            `El registro de factura se ha eliminado correctamente`,
            'success'
          );
          this.gridArray = this.gridArray.filter(
            (objeto) => objeto.id !== element.id
          );
          this.flagSearch = this.gridArray.length != 0 ? true : false;
        },
        error: (err: { message: any }) => {
          this.spinnerSrv.loadingHide();
        },
      });
    }
  }

  comboEstados() {
    this.facturaPoseedorEstadosControllerService.findAll11().subscribe({
      next: (data: Array<FacturaEstadoDTO>) => {
        this.estadoArray = data!;
      },
      error: () => { },
    });
  }

  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.searchForm.controls[controlName]?.touched ||
        this.searchForm.controls[controlName]?.dirty) &&
      this.searchForm.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }

  showClearButton(formName: string): boolean {
    return this.searchForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.searchForm.get(formName)?.setValue(null);
  }

  openModalUploadInvoice(element?: any): void {
    const dialogRef = this.dialog.open(
      ManagersAgreementsInvoiceNewDocumentDialogComponent,
      {
        width: '650px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          itemOpen: element,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }

  descargar(documento: any) {
    if(documento?.id) {
      this.spinnerSrv.loadingShow();
      this.documentService.descargarDocumento(documento.id).subscribe({
        next: (response) => {
          this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Se ha descargado el documento correctamente',
          'success'
        );
        this.downloadService.downloadBlob(response, documento.nombre);
      },
      error: () => {
        this.spinnerSrv.loadingHide();
      },
    });
  }
  }

  descargarDetallePrefacturacion(documento: any) {
    this.facturaGestorAcuerdoControllerService.prefacturaDetalle(documento.id, 'response')
      .subscribe((res: any) => {
        const filename = this.downloadService.getFileName(
          res.headers,
          'Prefacturación.xlsx'
        );
        this.downloadService.downloadBlob(res.body!, filename!);
      });
  }

  registrarFactura(item: any) {
    this.spinnerSrv.loadingShow();
    this.facturaGestorAcuerdoControllerService.registrarFactura(item.id)
      .subscribe({
        next: (res: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            `La factura se ha registrado correctamente`,
            'success'
          );
          this.searchData();
        },
        error: (err: { message: any }) => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  confirmacionCambioEstado(id?: any, estadoId?: any): void {
    Swal.fire({
      text: `¿Desea cambiar el estado del registro por Aceptada por Envalora?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.actualizarEstado(id, estadoId);
      }
    });
  }

  actualizarEstado(id?: any, estadoId?: any) {
    if (id && estadoId) {
      this.spinnerSrv.loadingShow();
      this.facturaGestorAcuerdoControllerService
        .actualizarEstado(id, estadoId)
        .subscribe({
          next: () => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              `El registro de factura se ha actualizado correctamente`,
              'success'
            );
            this.searchData();
          },
          error: (err: { message: any }) => {
            this.spinnerSrv.loadingHide();
          },
        });
    }
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  canAccessExport(): boolean {
    return this.authService.can('acuerdo-indirecto-facturas', 'update-exportar');
  }

  canAccessEnvalora(): boolean {
    return this.canViewResource('AI-ENV-GEST') || this.canViewResource('AI-ENV-CONS');
  }

  canAccessInformeContabilizacion(): boolean {
    return this.authService.can('acuerdo-indirecto-facturas', 'access-informe-contabilizacion');
  }

  canViewRegistrada(): boolean {
    return this.authService.can('acuerdo-indirecto-facturas-detalle', 'view-registrada');
  }

  canAccessAll(list: any) {
    const resultDelete = this.authService.can('acuerdo-indirecto-facturas', 'delete');
    const resultUpFactura = this.authService.can(
      'acuerdo-indirecto-facturas',
      'update'
    );
    const resultDownloadAutofactura = this.authService.can(
      'acuerdo-indirecto-facturas',
      'download-autofactura'
    );
    const resultDownloadFactura = this.authService.can(
      'acuerdo-indirecto-facturas',
      'download-factura'
    );
    const resultUpdateAccept = this.authService.can(
      'acuerdo-indirecto-facturas',
      'update-accept'
    );
    const resultReject = this.authService.can(
      'acuerdo-indirecto-facturas',
      'reject-factura'
    );

    const isGestorEnvalora = this.canViewResource('AI-ENV-GEST');
    const resultRegistrate = this.authService.can(
      'acuerdo-indirecto-facturas-detalle',
      'registrar'
    );

    const resultDetail = this.authService.can(
      'acuerdo-indirecto-facturas-detalle',
      'access-all'
    );

    const isConsultaEnvalora = this.canViewResource('AI-ENV-CONS');

    const listPermission = list.map((objeto: any) => {
      const estado1 = objeto.estado && objeto.estado.id === 1; //Pdte Factura
      const estado2 = objeto.estado && objeto.estado.id === 2; //Facturada
      const estado3 = objeto.estado && objeto.estado.id === 3; //Aceptada
      const estado4 = objeto.estado && objeto.estado.id === 4; //Rechazada
      const estado5 = objeto.estado && objeto.estado.id === 5; //Pdte Revisión

      let formattedDate =
        objeto.fechaFactura != null
          ? this.datePipe.transform(objeto.fechaFactura, 'dd/MM/yyyy')
          : null;
      objeto.fechaMFactura = formattedDate;

      let formattedDateM =
        objeto.fechaAutofactura != null
          ? this.datePipe.transform(objeto.fechaAutofactura, 'dd/MM/yyyy')
          : null;
      objeto.fechaMAutofactura = formattedDateM;
      let fechaMFacturaUipath =
        objeto.fechaFacturaUipath != null
          ? this.datePipe.transform(objeto.fechaFacturaUipath, 'dd/MM/yyyy')
          : null;
      objeto.fechaMFacturaUipath = fechaMFacturaUipath;
      return {
        ...objeto,
        canAccessView: resultDetail || isConsultaEnvalora,
        canAccessDelete: resultDelete && estado1,
        canAccessUpInvoice: resultUpFactura && (estado1 || estado4),
        canAccessDonwloadInvoice: (resultDownloadFactura || isConsultaEnvalora) && (estado2 || estado3 || estado4 || estado5) && objeto.documento,
        canAccessDonwloadSelfInvoice: (resultDownloadAutofactura || isConsultaEnvalora) && objeto.documentoAutofactura,
        canRejectInvoice: resultReject && estado2,
        canAccessRegistrate: resultRegistrate && estado3 && !objeto.registrada,
        canAccessAcceptInvoice: (resultUpdateAccept && estado2) || (isGestorEnvalora && estado4),
        canRejectInvoiceRevision: resultReject && estado5,
        canAccessAcceptInvoiceRevision: (resultUpdateAccept && estado5) || (isGestorEnvalora && estado5),
      };
    });

    return listPermission;
  }

  onlyNumberKey(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control'];

    if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) return;

    // Permitir números y teclas adicionales definidas
    if (!/^[0-9]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  onlyNumberCommaKey(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control'];

    if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) return;

    // Permitir números y teclas adicionales definidas
    if (!/^[0-9;]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  openModalMotivoRechazo(item:any){
    const dialogRef = this.dialog.open(
      ManagersAgreementsInvoiceRejectDialogComponent,
      {
        width: '750px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          info: item,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }
// toggleFiltros(): void {
//     this.mostrarFiltros = !this.mostrarFiltros;
//   }

//   quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
//     const control = this.searchForm.get(filtro.campo);
//     if (!control) {
//       return;
//     }

//     if (filtro.value !== undefined) {
//       const current = control.value as any[];
//       if (Array.isArray(current)) {
//         const updated = current.filter((v: any) => {
//           if (typeof v === 'object' && typeof filtro.value === 'object') {
//             const currentKey = v?.id ?? v?.codigo ?? v;
//             const targetKey = filtro.value?.id ?? filtro.value?.codigo ?? filtro.value;
//             return currentKey !== targetKey;
//           }
//           return v !== filtro.value;
//         });
//         control.setValue(updated.length ? updated : null);
//       }
//     } else {
//       if (filtro.campo === 'abonoS' || filtro.campo === 'abonoN') {
//         control.setValue(false);
//       } else {
//         control.reset();
//       }
//     }

//     this.pageNumber = 0;
//   }

  // get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
  //   const filtros: { label: string; campo: string; value?: any }[] = [];

  //   const gestores = this.searchForm.get('gestor')?.value as any[];
  //   if (Array.isArray(gestores) && gestores.length) {
  //     gestores.forEach((gestor: any) => {
  //       filtros.push({
  //         label: ` ${this.getGestorDescription(gestor)}`,
  //         campo: 'gestor',
  //         value: gestor,
  //       });
  //     });
  //   }

  //   const idgestor = this.searchForm.get('idgestor')?.value;
  //   if (idgestor) filtros.push({ label: `ID gestor: ${idgestor}`, campo: 'idgestor' });

  //   const codigoDocumento = this.searchForm.get('codigo_documento')?.value;
  //   if (codigoDocumento?.trim()) {
  //     filtros.push({ label: `Documento: ${codigoDocumento.trim()}`, campo: 'codigo_documento' });
  //   }

  //   const razonSocial = this.searchForm.get('razon_social')?.value;
  //   if (razonSocial?.trim()) {
  //     filtros.push({ label: `Razón social: ${razonSocial.trim()}`, campo: 'razon_social' });
  //   }

  //   const nimaGestor = this.searchForm.get('nima_gestor')?.value;
  //   if (nimaGestor?.trim()) {
  //     filtros.push({ label: `NIMA: ${nimaGestor.trim()}`, campo: 'nima_gestor' });
  //   }

  //   const numeroAutofactura = this.searchForm.get('numero_autoFactura')?.value;
  //   if (numeroAutofactura) {
  //     filtros.push({ label: `Nº prefactura: ${numeroAutofactura}`, campo: 'numero_autoFactura' });
  //   }

  //   const fechaAutofactura = this.searchForm.get('fecha_autoFactura')?.value;
  //   if (fechaAutofactura) {
  //     filtros.push({
  //       label: `Fecha prefactura: ${this.datePipe.transform(fechaAutofactura, 'dd/MM/yyyy')}`,
  //       campo: 'fecha_autoFactura',
  //     });
  //   }

  //   const numeroFacturaGestor = this.searchForm.get('numero_facturaGestor')?.value;
  //   if (numeroFacturaGestor?.trim()) {
  //     filtros.push({ label: `Nº factura: ${numeroFacturaGestor.trim()}`, campo: 'numero_facturaGestor' });
  //   }

  //   const fechaFacturaGestor = this.searchForm.get('fecha_facturaGestor')?.value;
  //   if (fechaFacturaGestor) {
  //     filtros.push({
  //       label: `Fecha factura: ${this.datePipe.transform(fechaFacturaGestor, 'dd/MM/yyyy')}`,
  //       campo: 'fecha_facturaGestor',
  //     });
  //   }

  //   const estados = this.searchForm.get('estado')?.value as any[];
  //   if (estados?.length) {
  //     estados.forEach((estado: any) => {
  //       filtros.push({
  //         label: `Estado: ${estado?.descripcion ?? String(estado)}`,
  //         campo: 'estado',
  //         value: estado,
  //       });
  //     });
  //   }

  //   if (this.searchForm.get('registrada')?.value === true) {
  //     filtros.push({ label: 'Registrada: Sí', campo: 'registrada' });
  //   }

  //   if (this.searchForm.get('abonoS')?.value === true) {
  //     filtros.push({ label: 'Abono: Sí', campo: 'abonoS' });
  //   }

  //   if (this.searchForm.get('abonoN')?.value === true) {
  //     filtros.push({ label: 'Abono: No', campo: 'abonoN' });
  //   }

  //   const ordenes = this.searchForm.get('orden')?.value;
  //   if (Array.isArray(ordenes) && ordenes.length) {
  //     ordenes.forEach((ordenCodigo: string) => {
  //       const opcionOrden = this.orden.find((item: DiccionarioElementoDTO) => item.codigo === ordenCodigo);
  //       filtros.push({
  //         label: `Orden: ${opcionOrden?.descripcionCorta ?? String(ordenCodigo)}`,
  //         campo: 'orden',
  //         value: ordenCodigo,
  //       });
  //     });
  //   } else if (ordenes) {
  //     const opcionOrden = this.orden.find((item: DiccionarioElementoDTO) => item.codigo === ordenes);
  //     filtros.push({ label: `Orden: ${opcionOrden?.descripcionCorta ?? String(ordenes)}`, campo: 'orden' });
  //   }

  //   const tipoOrden = this.searchForm.get('tipoOrden')?.value;
  //   if (tipoOrden) {
  //     const label =
  //       tipoOrden === 'ASC'
  //         ? 'Ascendente'
  //         : tipoOrden === 'DESC'
  //         ? 'Descendente'
  //         : String(tipoOrden);
  //     filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
  //   }

  //   return filtros;
  // }


}
